import { render, staticRenderFns } from "./AccountDeletionCard.vue?vue&type=template&id=8e17696a&scoped=true&"
import script from "./AccountDeletionCard.vue?vue&type=script&lang=js&"
export * from "./AccountDeletionCard.vue?vue&type=script&lang=js&"
import style0 from "./AccountDeletionCard.vue?vue&type=style&index=0&id=8e17696a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e17696a",
  null
  
)

export default component.exports